import React, { useState } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useAuthState } from "../contexts/AuthContext";
import { withRouter } from "react-router-dom";
import publicIp from 'ip';

// material components
import {
  Button,
  Container,
  createStyles,
  LinearProgress,
  Theme,
} from "@material-ui/core";
import { CheckCircleOutline, ErrorOutline } from "@material-ui/icons";

// api
import { sanaVerifyRequest } from "../api/auth";

// styles
import useStyles from "../styles/verifyStyles";

// utils
import { blobToFile, dataURLtoFile } from "../utils";

// layout
import AuthLayout from "../components/AuthLayout";
import { sanaBaseUrl } from "../constants";

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5,
      width: "100%",
      margin: 24,
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
    },
    bar: {
      borderRadius: 5,
    },
  })
)(LinearProgress);

const Verify = (props: any) => {

  // const { authTypeValue } = props.location?.state;


  const classes = useStyles();
  const state = useAuthState();
  // page vars
  const [uploading, setUploading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [progress, setProgress] = useState(0);

  // methods
  const onUpload = (event: any) => {
    var percentCompleted = Math.round((event.loaded * 100) / event.total);
    setProgress(percentCompleted);
  };

  const upload = React.useCallback(async (
    token: string,
    returnUrl: string,
    requestNo: string,
    uniqueId: string,
  ) => {
    try {

      const locationIp = publicIp.address();

      const officeCode = state.officeCode;

      await sanaVerifyRequest(
        blobToFile(state.selfieVideo!, "selfieVideo.webm"),
        dataURLtoFile(state.signature, "signature.png"),
        dataURLtoFile(state.selfieImg!, "selfieImg.png"),
        "audio",
        token,
        returnUrl,
        requestNo,
        uniqueId,
        state.positionInfo,
        locationIp ?? '',
        officeCode ?? '',
        onUpload
      );
      setSuccess(true);
      setUploading(false);
      setTimeout(() => {
        // window.location.href = `${state.returnUrl}/?token=6:${state.token}`;
        window.location.href = sanaBaseUrl;
      }, 20000);
    } catch (error) {
      setSuccess(false);
      setUploading(false);
      setTimeout(() => {
        window.location.href = sanaBaseUrl;
      }, 9000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.positionInfo,
    state.requestNo,
    state.returnUrl,
    state.selfieVideo,
    state.signature,
    state.token,
    state.uniqueId,
    state.officeCode,
  ]);

  React.useEffect(() => {

    const token = localStorage.getItem('token');
    const returnUrl = localStorage.getItem('returnUrl');
    const requestNo = localStorage.getItem('requestNo');
    const uniqueId = localStorage.getItem('uniqueId');

    if (token && returnUrl && requestNo && uniqueId) upload(token, returnUrl, requestNo, uniqueId);


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
      >
        <Container>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
          >
            {uploading ? (
              <>
                <BorderLinearProgress
                  variant="determinate"
                  value={progress}
                />
                <Typography className={classes.info}>
                  در حال ارسال ...
                </Typography>
                <Typography className={classes.info}>
                  این مرحله وابسته به سرعت اینترنت شماست
                </Typography>
                <Typography className={classes.info}>
                  ممکن است زمان اندکی نیاز داشته باشد لطفا شکیبا باشید
                </Typography>
              </>
            ) : success ? (
              <>
                <CheckCircleOutline
                  className={classes.successIcon}
                  fontSize="inherit"
                />

{/* درخواست احراز هویت با موفقیت ارسال شد. */}
                <Typography align="center" className={classes.successMessage}>
                درخواست احراز هویت با موفقیت ارسال شد. پاسخ احراز هویت شما در مدت کوتاهی و از طریق پیامک به شماره تلفن همراه ثبت نامی ارسال خواهد شد که در صورت تائید شامل رمز شخصی ثنا (کد ثنا) خواهد بود. لازم به ذکر است که پیامک از سمت قوه قضائیه ارسال می شود و برای پیگیری عدم ارسال پیامک می بایست با مرکز تماس پشتیبانی قوه قضائیه تماس حاصل فرمایید.
                </Typography>
              </>
            ) : (
              <>
                <ErrorOutline
                  className={classes.errorIcon}
                  fontSize="inherit"
                  color="primary"
                />
                <Typography className={classes.rejectMessage}>
                  ارسال اطلاعات ناموفق بود
                </Typography>
                <Typography>
                  متاسفانه درخواست احراز هویت شما به دلیل بروز خطا به درستی
                  ارسال نشد. لطفا پس از بررسی اینترنت خود و <b>بدون پرداخت هزینه</b> از طریق لینک زیر دوباره تلاش کنید.
                  https://sana.adliran.ir
                </Typography>
                {/* <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.returnButton}
                >
                  درحال بازگشت به سامانه ثنا...
                </Button> */}
              </>
            )}
          </Box>
        </Container>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="70px"
          paddingTop={'80px'}
        >
          <Typography align="center" variant="subtitle1" style={{ fontWeight: 'bold' }}>
            مرکز تماس  پشتیبانی قوه قضائیه: 57798000 -021 یا 1470- 021
          </Typography>
          

         {/* <Typography align="center" variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                مرکز تماس پشتیبانی احراز هویت هوشمند ویدا: 66066142 -021
          </Typography> */}
          <Typography align="center" variant="caption">
            کلیه حقوق سامانه احراز هویت دیجیتال ویدا متعلق به شرکت کیاهوشان است.
          </Typography>
        </Box>



      </Box>
    </div>
  );
};
export default withRouter(Verify);
